import { Image } from "hec/components/image";

import { sanitizeHtml } from "~/utils/sanitize-html";

import type { TwoUpImageTextProps } from "./types";

export const TwoUpImageText = ({
  sectionTitle,
  image1Url,
  image1Alt,
  image2Url,
  image2Alt,
  headline,
  body,
  attributes,
}: TwoUpImageTextProps) => {
  const { className: extraClassName, ...restAttrs } = attributes ?? {};
  return (
    <section
      {...restAttrs}
      className={`w-full bg-white px-4 py-6 lg:px-8 lg:py-10 ${extraClassName ?? ""}`}
    >
      <div className="mx-auto flex w-full max-w-[900px] flex-col gap-6 lg:gap-8">
        {sectionTitle ? (
          <h2 className="text-center text-2xl font-bold text-primary lg:text-3xl">
            {sectionTitle}
          </h2>
        ) : null}

        {image1Url && image2Url ? (
          <div className="flex flex-col gap-4 lg:flex-row lg:gap-6">
            <div className="lg:w-1/2">
              <Image
                src={image1Url}
                alt={image1Alt ?? ""}
                className="h-auto w-full object-cover"
                maxCssWidth={450}
                sizes="(min-width: 1024px) 450px, 100vw"
              />
            </div>
            <div className="lg:w-1/2">
              <Image
                src={image2Url}
                alt={image2Alt ?? ""}
                className="h-auto w-full object-cover"
                maxCssWidth={450}
                sizes="(min-width: 1024px) 450px, 100vw"
              />
            </div>
          </div>
        ) : null}

        {headline || body ? (
          <div className="text-center">
            {headline ? (
              <h3 className="mb-4 text-xl font-bold text-primary lg:text-2xl">
                {headline}
              </h3>
            ) : null}
            {body ? (
              <div
                className="text-base text-primary"
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(body),
                }}
              />
            ) : null}
          </div>
        ) : null}
      </div>
    </section>
  );
};
